import { formatAddress } from '../types';

import { CurrentFacilityData } from '~/modules/settings/_state/facilityDetailsForm.state';
import { createQueryHook } from '~/shared/providers/api';

export interface FacilityQueryParams {
  facilityId: string;
}

export interface FacilityQueryResult {
  facility: CurrentFacilityData | null;
}

export const useFacilityQuery = createQueryHook(
  'settings.teamPermissions.facility',
  (params: FacilityQueryParams) => ({
    facility: {
      __args: { id: params.facilityId },
      id: true,
      facilityName: true,
      address: {
        streetAddress: true,
        city: true,
        state: true,
        postalCode: true,
      },
    },
  }),
  {
    select: (data): FacilityQueryResult => ({
      facility: data?.facility
        ? {
            id: data.facility.id,
            name: data.facility.facilityName,
            address: formatAddress(data.facility.address),
          }
        : null,
    }),
  },
);
